import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What capabilities should a DevOps environment pose?",
    answer: `<p>Ideally, a DevOps environment should have a comprehensive deployment set up for software code, policy enforcement across servers, and automating configuration of security. This will help significantly as any changes could be controlled and tested.</p>`,
  },
  {
    question: "What is DevOps managed services?",
    answer: `<p>DevOps managed services comprise of Continuous integration and Continuous Delivery (CI & CD). These software development practices are applied at each step of the delivery process. The objective here is to ensure that the whole project is fully functional, and updates take place in a continuous, and traceable manner.</p>`,
  },
  {
    question: "What is some standard practice of DevOps?",
    answer: `<p>Here are some standard practices of DevOps: Continuous Delivery, Continuous Deployment, Continuous Monitoring, Continuous Integration, Continuous testing, and Infrastructure as Code (IaC).</p>`,
  },
  {
    question: "What are the Five Phases of DevOps Maturity?",
    answer: `<p>Following are the five phases of DevOps Maturity:</p>
    <ul>
    <li>Ad Hoc (Chaotic stage)</li>
    <li>Automating Repeatable workflows (Continuous Integration)</li>
    <li>Defining organization-wide standards (Continuous Delivery)</li>
    <li>Measuring against set goals (Continuous Deployment)</li>
    <li>Optimizing for improved performance (Continuous Operations)</li>
    </ul>
    `,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Devops Enablement FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
